import React, { useState, useEffect } from "react";
import contactEditIcon from "../../../assets/images/contact-edit-icon.svg";
import sliderCloseIcon from "../../../assets/images/slider-close-icon.svg";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment-timezone";
import {
  updatecustomMessage,
  fetchCustomMessages,
  isAdminUser,
  deleteCustomMessage,
} from "../../../redux/action";
import { Box, Image } from "@chakra-ui/react";

export default function MissedCalls() {
  const userSelectedFont = useSelector((state) => state.settings.fontsize);
  const dispatch = useDispatch();
  const custommessages = useSelector((state) => state.customMessages);
  const [defaultMessage, setDefaultMessage] = useState({});
  const [newMessageInfo, setNewMessageInfo] = useState({
    id: false,
    name: "",
    messageBody: "",
    startTime: "",
    endTime: "",
    days: {
      mon: false,
      tue: false,
      wed: false,
      thu: false,
      fri: false,
      sat: false,
      sun: false,
    },
  });

  const getCustomMessages = () => {
    dispatch(fetchCustomMessages());
  };

  useEffect(() => {
    getCustomMessages();
  }, []);

  const clearState = () => {
    setNewMessageInfo({
      id: false,
      name: "",
      messageBody: "",
      startTime: "",
      endTime: "",
      days: {
        mon: false,
        tue: false,
        wed: false,
        thu: false,
        fri: false,
        sat: false,
        sun: false,
      },
    });
  };
  const handleChangeInfo = (e) => {
    let key = e.target.name;
    let value = e.target.value;
    setNewMessageInfo({
      ...newMessageInfo,
      [key]: value,
    });
  };

  const updateDaysCheckBox = (target) => {
    //let info =newMessageInfo
    newMessageInfo.days[target.name] = false;
    if (target.checked) {
      newMessageInfo.days[target.name] = true;
    }
    setNewMessageInfo({ ...newMessageInfo });
  };

  const getEncodedDays = (days) => {
    let daysArr = [];
    if (days.mon) daysArr[daysArr.length] = 1;
    if (days.tue) daysArr[daysArr.length] = 2;
    if (days.wed) daysArr[daysArr.length] = 3;
    if (days.thu) daysArr[daysArr.length] = 4;
    if (days.fri) daysArr[daysArr.length] = 5;
    if (days.sat) daysArr[daysArr.length] = 6;
    if (days.sun) daysArr[daysArr.length] = 7;
    return JSON.stringify(daysArr);
  };

  const getDecodedDays = (daysStr) => {
    let daysArr = JSON.parse(daysStr);
    let days = {
      mon: false,
      tue: false,
      wed: false,
      thu: false,
      fri: false,
      sat: false,
      sun: false,
    };
    for (var i = 0; i < daysArr.length; i++) {
      if (daysArr[i] == 1) {
        days.mon = true;
      } else if (daysArr[i] == 2) {
        days.tue = true;
      } else if (daysArr[i] == 3) {
        days.wed = true;
      } else if (daysArr[i] == 4) {
        days.thu = true;
      } else if (daysArr[i] == 5) {
        days.fri = true;
      } else if (daysArr[i] == 6) {
        days.sat = true;
      } else if (daysArr[i] == 7) {
        days.sun = true;
      }
    }
    return days;
  };

  const customUpdateToggle = (id) => {
    clearState();

    let currentInfo = {};

    let info = custommessages.custom_missed_calls.find((x) => x.id === id);
    console.log(info);
    currentInfo.id = info.id;
    currentInfo.name = info.name;
    currentInfo.messageBody = info.text_message;
    currentInfo.days = getDecodedDays(info.active_days);

    let utcTime = moment.utc(info.start_time, ["h:m a", "H:m"]).local();
    currentInfo.startTime = utcTime.format("HH:mm:ss");

    utcTime = moment.utc(info.end_time, ["h:m a", "H:m"]).local();
    currentInfo.endTime = utcTime.format("HH:mm:ss");

    console.log(currentInfo);

    setNewMessageInfo(currentInfo);
    console.log(newMessageInfo);
  };

  const handleUpdateDefault = () => {
    let form = new FormData();
    form.append("text_message", defaultMessage.text_message);
    form.append("voice_message", "");
    form.append("binary_files", "");
    form.append("message_type", 1);
    form.append("forward_type", 0);
    form.append("forward_date_time", null);
    form.append("is_active", 1);

    dispatch(updatecustomMessage(form, defaultMessage.id));
  };

  const handleSubmit = () => {
    let form = new FormData();
    let startTime = moment(newMessageInfo.startTime, ["h:m a", "H:m"])
      .utc()
      .format("HH:mm:ss");
    let endTime = moment(newMessageInfo.endTime, ["h:m a", "H:m"])
      .utc()
      .format("HH:mm:ss");
    form.append("voice_message", "");
    form.append("binary_files", "");
    form.append("message_type", 1);
    form.append("forward_type", 1);
    form.append("forward_date_time", null);
    form.append("is_active", 1);
    form.append("text_message", newMessageInfo.messageBody);
    form.append("name", newMessageInfo.name);
    form.append("start_time", startTime);
    form.append("end_time", endTime);
    form.append("active_days", getEncodedDays(newMessageInfo.days));
    form.append("timezone", moment.tz.guess());

    if (newMessageInfo.id) {
      dispatch(updatecustomMessage(form, newMessageInfo.id));
    } else {
      dispatch(updatecustomMessage(form));
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 main-section-scroll-height">
          <div class="row mt-5">
            {custommessages &&
              custommessages.default.map((customMessage) => {
                let local_date = moment
                  .utc(
                    customMessage.created_at &&
                      customMessage.created_at.replace(/-/g, "/")
                  )
                  .local()
                  .format("MMM DD, hh:mm A");

                return (
                  <div
                    key={customMessage.id}
                    class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
                    <div class="basic-card">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex gap-2 align-items-center">
                          <div
                            style={{
                              fontSize:
                                userSelectedFont === "small"
                                  ? "20px"
                                  : userSelectedFont === "medium"
                                  ? "22px"
                                  : userSelectedFont === "large"
                                  ? "24px"
                                  : "24px",
                            }}
                            class="head me-2">
                            Default
                          </div>
                          <div
                            style={{
                              fontSize:
                                userSelectedFont === "small"
                                  ? "11px"
                                  : userSelectedFont === "medium"
                                  ? "13px"
                                  : userSelectedFont === "large"
                                  ? "15px"
                                  : "15px",
                              marginTop: "2px",
                            }}
                            class="date">
                            {local_date}
                          </div>
                        </div>
                        <div
                          data-bs-toggle="offcanvas"
                          data-bs-target="#defaultMessageCanvas"
                          aria-controls="defaultMessageCanvas"
                          onClick={() => setDefaultMessage(customMessage)}>
                          <Image
                            boxSize={
                              userSelectedFont === "small"
                                ? "24px"
                                : userSelectedFont === "medium"
                                ? "26px"
                                : userSelectedFont === "large"
                                ? "30px"
                                : "30px"
                            }
                            src={contactEditIcon}
                            // class="img-fluid"
                          />
                        </div>
                      </div>
                      {/*    <div class="subject">
            Hi thank you for calling the Cain Law Office.
    </div>*/}
                      <div
                        style={{
                          fontSize:
                            userSelectedFont === "small"
                              ? "12px"
                              : userSelectedFont === "medium"
                              ? "14px"
                              : userSelectedFont === "large"
                              ? "16px"
                              : "16px",
                        }}
                        class="message">
                        {customMessage && customMessage.text_message === null
                          ? "(empty)"
                          : customMessage &&
                            customMessage.text_message &&
                            customMessage.text_message.length > 200
                          ? customMessage.text_message.slice(0, 200) + "..."
                          : customMessage.text_message}
                      </div>
                    </div>
                  </div>
                );
              })}

            {custommessages &&
              custommessages.custom_missed_calls.map((customMessage) => {
                let local_date = moment
                  .utc(
                    customMessage.created_at &&
                      customMessage.created_at.replace(/-/g, "/")
                  )
                  .local()
                  .format("MMM DD, hh:mm A");

                return (
                  <div
                    key={customMessage.id}
                    class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
                    <div class="basic-card">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex gap-2 align-items-center">
                          <div
                            style={{
                              fontSize:
                                userSelectedFont === "small"
                                  ? "20px"
                                  : userSelectedFont === "medium"
                                  ? "22px"
                                  : userSelectedFont === "large"
                                  ? "24px"
                                  : "24px",
                            }}
                            class="head me-2">
                            {customMessage.name === null
                              ? "(empty)"
                              : customMessage.name}
                          </div>
                          <div
                            style={{
                              fontSize:
                                userSelectedFont === "small"
                                  ? "11px"
                                  : userSelectedFont === "medium"
                                  ? "13px"
                                  : userSelectedFont === "large"
                                  ? "15px"
                                  : "15px",
                              marginTop: "2px",
                            }}
                            class="date">
                            {local_date}
                          </div>
                        </div>
                        <div
                          data-bs-toggle="offcanvas"
                          data-bs-target="#addCustomMessageCanvas"
                          aria-controls="addCustomMessageCanvas"
                          onClick={() => customUpdateToggle(customMessage.id)}>
                          <Image
                            boxSize={
                              userSelectedFont === "small"
                                ? "24px"
                                : userSelectedFont === "medium"
                                ? "26px"
                                : userSelectedFont === "large"
                                ? "30px"
                                : "30px"
                            }
                            src={contactEditIcon}
                            class="img-fluid"
                          />
                        </div>
                      </div>
                      {/*<div class="subject">
          New After an hour message.
  </div>*/}
                      <div
                        style={{
                          fontSize:
                            userSelectedFont === "small"
                              ? "12px"
                              : userSelectedFont === "medium"
                              ? "14px"
                              : userSelectedFont === "large"
                              ? "16px"
                              : "16px",
                        }}
                        class="message">
                        {customMessage && customMessage.text_message === null
                          ? "(empty)"
                          : customMessage &&
                            customMessage.text_message &&
                            customMessage.text_message.length > 200
                          ? customMessage.text_message.slice(0, 200) + "..."
                          : customMessage.text_message}
                      </div>
                    </div>
                  </div>
                );
              })}

            <div
              data-bs-toggle="offcanvas"
              data-bs-target="#addCustomMessageCanvas"
              aria-controls="addCustomMessageCanvas"
              class="col-md-4 col-lg-4 col-sm-12 col-xs-12"
              onClick={() => clearState()}>
              <div class="custom-card">
                <div
                  style={{
                    fontSize:
                      userSelectedFont === "small"
                        ? "18px"
                        : userSelectedFont === "medium"
                        ? "20px"
                        : userSelectedFont === "large"
                        ? "22px"
                        : "22px",
                  }}
                  class="label">
                  Add New Message
                </div>
              </div>
            </div>
          </div>

          <div
            class="offcanvas offcanvas-end"
            tabIndex="-1"
            id="addCustomMessageCanvas"
            aria-labelledby="addCustomMessageCanvasLabel">
            <div class="offcanvas-header">
              <div
                style={{
                  fontSize:
                    userSelectedFont === "small"
                      ? "16px"
                      : userSelectedFont === "medium"
                      ? "18px"
                      : userSelectedFont === "large"
                      ? "20px"
                      : "20px",
                }}
                class="offcanvas-title"
                id="addCustomMessageCanvasLabel">
                New Message
              </div>
              <button
                type="button"
                class="slider-close-btn"
                data-bs-dismiss="offcanvas">
                <img src={sliderCloseIcon} class="img-fluid" />
              </button>
            </div>
            <div class="offcanvas-body">
              <div class="mt-2">
                <input
                  type="text"
                  value={newMessageInfo.name}
                  name="name"
                  onChange={handleChangeInfo}
                  class="form-control slider-inputs"
                  placeholder="Title"
                />
              </div>
              <div class="mt-2">
                <textarea
                  class="form-control slider-inputs text-area-height"
                  value={newMessageInfo.messageBody}
                  onChange={handleChangeInfo}
                  name="messageBody"
                  placeholder="Message Body"
                  aria-label="With textarea"></textarea>
              </div>
              <div class="mt-4 d-flex justify-content-between">
                <div>
                  <span
                    style={{
                      fontSize:
                        userSelectedFont === "small"
                          ? "14px"
                          : userSelectedFont === "medium"
                          ? "16px"
                          : userSelectedFont === "large"
                          ? "18px"
                          : "18px",
                    }}>
                    Start Time
                  </span>
                  <input
                    type="time"
                    name="startTime"
                    value={newMessageInfo.startTime}
                    onChange={handleChangeInfo}
                    class="form-control slider-inputs mt-1"
                    placeholder="Start Time"
                  />
                </div>
                <div>
                  <span
                    style={{
                      fontSize:
                        userSelectedFont === "small"
                          ? "14px"
                          : userSelectedFont === "medium"
                          ? "16px"
                          : userSelectedFont === "large"
                          ? "18px"
                          : "18px",
                    }}>
                    End Time
                  </span>
                  <input
                    type="time"
                    name="endTime"
                    value={newMessageInfo.endTime}
                    onChange={handleChangeInfo}
                    class="form-control slider-inputs mt-1"
                    placeholder="End Time"
                  />
                </div>
              </div>

              <div class="row mt-4">
                <strong>
                  <label
                    style={{
                      fontSize:
                        userSelectedFont === "small"
                          ? "14px"
                          : userSelectedFont === "medium"
                          ? "16px"
                          : userSelectedFont === "large"
                          ? "18px"
                          : "18px",
                    }}
                    class="form-label">
                    Days:
                  </label>
                </strong>
                <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-2">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      name="mon"
                      value=""
                      checked={newMessageInfo.days.mon}
                      onChange={(e) => {
                        updateDaysCheckBox(e.target);
                      }}
                      type="checkbox"
                      id="flexCheckDefault"
                    />
                    <label
                      style={{
                        fontSize:
                          userSelectedFont === "small"
                            ? "14px"
                            : userSelectedFont === "medium"
                            ? "16px"
                            : userSelectedFont === "large"
                            ? "18px"
                            : "18px",
                      }}
                      class="form-check-label"
                      htmlFor="flexCheckDefault">
                      Monday
                    </label>
                  </div>
                </div>
                <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-2">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      name="tue"
                      value=""
                      checked={newMessageInfo.days.tue}
                      onChange={(e) => {
                        updateDaysCheckBox(e.target);
                      }}
                      type="checkbox"
                      id="flexCheckDefault"
                    />
                    <label
                      style={{
                        fontSize:
                          userSelectedFont === "small"
                            ? "14px"
                            : userSelectedFont === "medium"
                            ? "16px"
                            : userSelectedFont === "large"
                            ? "18px"
                            : "18px",
                      }}
                      class="form-check-label"
                      htmlFor="flexCheckDefault">
                      Tuesday
                    </label>
                  </div>
                </div>
                <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-2">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      name="wed"
                      value=""
                      checked={newMessageInfo.days.wed}
                      onChange={(e) => {
                        updateDaysCheckBox(e.target);
                      }}
                      type="checkbox"
                      id="flexCheckDefault"
                    />
                    <label
                      style={{
                        fontSize:
                          userSelectedFont === "small"
                            ? "14px"
                            : userSelectedFont === "medium"
                            ? "16px"
                            : userSelectedFont === "large"
                            ? "18px"
                            : "18px",
                      }}
                      class="form-check-label"
                      htmlFor="flexCheckDefault">
                      Wednesday
                    </label>
                  </div>
                </div>
                <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-2">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      name="thu"
                      value=""
                      checked={newMessageInfo.days.thu}
                      onChange={(e) => {
                        updateDaysCheckBox(e.target);
                      }}
                      type="checkbox"
                      id="flexCheckDefault"
                    />
                    <label
                      style={{
                        fontSize:
                          userSelectedFont === "small"
                            ? "14px"
                            : userSelectedFont === "medium"
                            ? "16px"
                            : userSelectedFont === "large"
                            ? "18px"
                            : "18px",
                      }}
                      class="form-check-label"
                      htmlFor="flexCheckDefault">
                      Thursday
                    </label>
                  </div>
                </div>
                <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-2">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      name="fri"
                      value=""
                      checked={newMessageInfo.days.fri}
                      onChange={(e) => {
                        updateDaysCheckBox(e.target);
                      }}
                      type="checkbox"
                      id="flexCheckDefault"
                    />
                    <label
                      style={{
                        fontSize:
                          userSelectedFont === "small"
                            ? "14px"
                            : userSelectedFont === "medium"
                            ? "16px"
                            : userSelectedFont === "large"
                            ? "18px"
                            : "18px",
                      }}
                      class="form-check-label"
                      htmlFor="flexCheckDefault">
                      Friday
                    </label>
                  </div>
                </div>
                <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-2">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      value=""
                      name="sat"
                      checked={newMessageInfo.days.sat}
                      onChange={(e) => {
                        updateDaysCheckBox(e.target);
                      }}
                      type="checkbox"
                      id="flexCheckDefault"
                    />
                    <label
                      style={{
                        fontSize:
                          userSelectedFont === "small"
                            ? "14px"
                            : userSelectedFont === "medium"
                            ? "16px"
                            : userSelectedFont === "large"
                            ? "18px"
                            : "18px",
                      }}
                      class="form-check-label"
                      htmlFor="flexCheckDefault">
                      Saturday
                    </label>
                  </div>
                </div>
                <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-2">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      name="sun"
                      checked={newMessageInfo.days.sun}
                      onChange={(e) => {
                        updateDaysCheckBox(e.target);
                      }}
                      value=""
                      type="checkbox"
                      id="flexCheckDefault"
                    />
                    <label
                      style={{
                        fontSize:
                          userSelectedFont === "small"
                            ? "14px"
                            : userSelectedFont === "medium"
                            ? "16px"
                            : userSelectedFont === "large"
                            ? "18px"
                            : "18px",
                      }}
                      class="form-check-label"
                      htmlFor="flexCheckDefault">
                      Sunday
                    </label>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-4">
                <button
                  class="slider-cancel-btn me-2"
                  disabled={!dispatch(isAdminUser())}
                  onClick={() =>
                    dispatch(deleteCustomMessage(newMessageInfo.id))
                  }
                  data-bs-dismiss="offcanvas">
                  Delete
                </button>

                <button
                  class="slider-cancel-btn me-2"
                  data-bs-dismiss="offcanvas">
                  Cancel
                </button>
                <button
                  class="slider-success-btn"
                  onClick={handleSubmit}
                  data-bs-dismiss="offcanvas">
                  {newMessageInfo.id ? "Update" : "Add"}
                </button>
              </div>
            </div>
          </div>

          {/*
    <div class="offcanvas offcanvas-end" tabindex="-1" id="afterHourMessageCanvas"
        aria-labelledby="afterHourMessageCanvasLabel">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="afterHourMessageCanvasLabel">After an Hour</h5>
            <button type="button" class="slider-close-btn" data-bs-dismiss="offcanvas"><img
                    src={sliderCloseIcon} class="img-fluid"/></button>
        </div>
        <div class="offcanvas-body">
            
            <div class="mt-2">
                <strong><label class="form-label">Label:</label></strong>
                <p>After an Hour</p>
            </div>
            <div class="mt-2">
             <input type="text" value={newMessageInfo.name} name="name" onChange={handleChangeInfo} class="form-control slider-inputs" placeholder="title" 
            
            />
            </div>
            <div class="mt-2">
                <textarea class="form-control slider-inputs text-area-height" name="messageBody" value={newMessageInfo.messageBody} onChange={handleChangeInfo} placeholder="Message Body" aria-label="With textarea"/>
            </div>
            <div class="mt-4 d-flex justify-content-between">
                <div>
                    <span>Start Time</span>
                    <input type="time" class="form-control slider-inputs mt-1" name="startTime" value={newMessageInfo.startTime} onChange={handleChangeInfo} placeholder="Start Time"/>
                </div>
                <div>
                    <span>End Time</span>
                    <input type="time" class="form-control slider-inputs mt-1" name="endTime" value={newMessageInfo.endTime} onChange={handleChangeInfo} placeholder="End Time"/>
                </div>
            </div>

            <div class="row mt-4">
                <strong><label class="form-label">Days:</label></strong>
                <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-2">
                    <div class="form-check">
                        <input class="form-check-input"  defaultChecked={ newMessageInfo.days.mon } onChange={ e  => { updateDaysCheckBox( e.target ) } } type="checkbox" value="" id="flexCheckDefault"/>
                        <label class="form-check-label" for="flexCheckDefault">
                          Monday
                        </label>
                      </div>
                </div>
                <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-2">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" defaultChecked={ newMessageInfo.days.tue } onChange={ e  => { updateDaysCheckBox( e.target ) } } id="flexCheckDefault"/>
                        <label class="form-check-label" for="flexCheckDefault">
                          Tuesday
                        </label>
                      </div>
                </div>
                <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-2">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" defaultChecked={ newMessageInfo.days.wed } onChange={ e  => { updateDaysCheckBox( e.target ) } } id="flexCheckDefault"/>
                        <label class="form-check-label" for="flexCheckDefault">
                          Wednesday
                        </label>
                      </div>
                </div>
                <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-2">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" defaultChecked={ newMessageInfo.days.thu } onChange={ e  => { updateDaysCheckBox( e.target ) } } id="flexCheckDefault"/>
                        <label class="form-check-label" for="flexCheckDefault">
                          Thursday
                        </label>
                      </div>
                </div>
                <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-2">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" defaultChecked={ newMessageInfo.days.fri } onChange={ e  => { updateDaysCheckBox( e.target ) } } id="flexCheckDefault"/>
                        <label class="form-check-label" for="flexCheckDefault">
                          Friday
                        </label>
                      </div>
                </div>
                <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-2">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" defaultChecked={ newMessageInfo.days.sat } onChange={ e  => { updateDaysCheckBox( e.target ) } } id="flexCheckDefault"/>
                        <label class="form-check-label" for="flexCheckDefault">
                          Saturday
                        </label>
                      </div>
                </div>
                <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-2">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" defaultChecked={ newMessageInfo.days.sun } onChange={ e  => { updateDaysCheckBox( e.target ) } } id="flexCheckDefault"/>
                        <label class="form-check-label" for="flexCheckDefault">
                          Sunday
                        </label>
                      </div>
                </div>
            </div>
            <div class="d-flex justify-content-end mt-4">
                <button class="slider-cancel-btn me-2" data-bs-dismiss="offcanvas">Cancel</button>
                <button class="slider-success-btn" onClick={handleSubmit}>Update</button>
            </div>
        </div>
    </div>
*/}

          <div
            class="offcanvas offcanvas-end"
            tabIndex="-1"
            id="defaultMessageCanvas"
            aria-labelledby="defaultMessageCanvasLabel">
            <div class="offcanvas-header">
              <h5 class="offcanvas-title" id="defaultMessageCanvasLabel">
                Default
              </h5>
              <button
                type="button"
                class="slider-close-btn"
                data-bs-dismiss="offcanvas">
                <img src={sliderCloseIcon} class="img-fluid" />
              </button>
            </div>
            <div class="offcanvas-body">
              <div class="mt-2">
                <strong>
                  <label class="form-label">Label:</label>
                </strong>
                <p>Default</p>
              </div>
              {/*<div class="mt-2">
             <input type="text" class="form-control slider-inputs" placeholder="title" 
             value="Hi thank you for calling the Cain Law Office."
             />
</div>*/}
              <div class="mt-5">
                <textarea
                  class="form-control slider-inputs text-area-height"
                  value={defaultMessage.text_message}
                  onChange={(e) =>
                    setDefaultMessage({
                      ...defaultMessage,
                      text_message: e.target.value,
                    })
                  }
                  placeholder="Message Body"
                  aria-label="With textarea"></textarea>
              </div>

              <div class="d-flex justify-content-end mt-4">
                <button
                  class="slider-cancel-btn me-2"
                  data-bs-dismiss="offcanvas">
                  Cancel
                </button>
                <button
                  class="slider-success-btn"
                  data-bs-dismiss="offcanvas"
                  onClick={handleUpdateDefault}>
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
